import { useContext, createContext } from 'react';
import { AwsCognitoUser } from '../models/user.model';

export const AppContext = createContext<{
  userHasAuthenticated: (isAuthenticated: boolean) => void;
  isAuthenticated: boolean;
  currentUser?: AwsCognitoUser;
}>({
  userHasAuthenticated: () => {},
  isAuthenticated: false,
  currentUser: undefined,
});

export function useAppContext() {
  return useContext(AppContext);
}
